import * as api from '../connectivity/api.logs';
import { call, put } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import * as types from '../constants/actionTypes';
import { showLoading, hideLoading } from 'react-redux-loading-bar';


export function* doRequestLogs(action) {
    const { assignmentId, dropboxId, precept, userId, to, from, ipAddress, uri, referer, val, method, event, role, offset, limit, append, sortField, sort } = action.payload;

    // Only show loading bar and disable fields for initial load, not pagination
    if (!append) {
        yield put(showLoading());
        yield put({
            type: types.REQUEST__STARTED,
            payload: {
                requestFrom: 'groups.doRequestLogs'
            }
        });
    }

    try {
        const logs = yield call(api.fetchDropboxLogs, dropboxId, {
            'assignment': assignmentId,
            'precept': precept,
            'user': userId,
            'to': to,
            'from': from,
            'ip_address': ipAddress,
            'uri' : uri,
            'referer': referer,
            'val': val,
            'method': method,
            'event': event,
            'role': role,
            'offset': offset,
            'limit': limit,
            'sortField': sortField,
            'sort': sort,
        });

        yield put({
            type: types.LOGS__REQUESTED__SUCCEEDED,
            payload: { logs, append, returnedCount: logs.entities.length }
        });
    } catch (e) {
        yield put({
            type: types.LOGS__REQUESTED__FAILED,
            message: e.message
        });
    }

    if (!append) {
        yield put({
            type: types.REQUEST__FINISHED,
            payload: {
                requestFrom: 'groups.doRequestLogs'
            }
        });
        yield put(hideLoading());
    }
}

export function* doRequestLogsSucceeded(action) {
    yield put({
        type: types.REQUEST__SUCCEEDED,
        payload: {
            requestFrom: 'groups.doRequestLogs'
        }
    });
}

export function* doRequestLogsFailed(action) {
    yield put({
        type: types.REQUEST__FAILED,
        payload: {
            requestFrom: 'groups.doRequestLogs'
        }
    });
}

export function* watchRequestLogs() {
    yield* takeLatest(types.LOGS__REQUESTED, doRequestLogs);
}

export function* watchRequestLogsSucceeded() {
    yield* takeLatest(types.LOGS__REQUESTED__SUCCEEDED, doRequestLogsSucceeded);
}

export function* watchRequestLogsFailed() {
    yield* takeLatest(types.LOGS__REQUESTED__FAILED, doRequestLogsFailed);
}


/** WEBPACK FOOTER **
 ** ./src/sagas/logs.saga.js
 **/